import Vue from 'vue'
import VueRouter from 'vue-router'

import Survey from '../views/Survey.vue'
import SurveyComplete from '../views/SurveyComplete.vue'
import SurveyExpired from '../views/SurveyExpired.vue'

import SurveyLayout from '@/layouts/SurveyLayout.vue'
import DefaultHeader from '@/layouts/DefaultHeader.vue'
import DefaultFooter from '@/layouts/DefaultFooter.vue'
import NotFound from '@/layouts/NotFound.vue'
import Index from '@/layouts/Index.vue'

Vue.use(VueRouter)

const routes = [
  {
    path: '/',
    component: SurveyLayout,
    children: [
      {
        path: '',
        name: 'index',
        components: {
          default: Index,
          header: DefaultHeader,
          footer: DefaultFooter
        }
      },
      {
        path: 'survey/:token',
        name: 'surveyPage',
        components: {
          default: Survey,
          header: DefaultHeader,
          footer: DefaultFooter
        }
      },
      {
        path: 'survey/:token/complete',
        name: 'surveyCompletePage',
        components: {
          default: SurveyComplete,
          header: DefaultHeader,
          footer: DefaultFooter
        }
      },
      {
        path: '/error',
        name: 'networkErrorPage',
        components: {
          default: SurveyExpired,
          header: DefaultHeader,
          footer: DefaultFooter
        }
      },
      {
        path: '/*',
        name: 'errorPage',
        components: {
          default: NotFound,
          header: DefaultHeader,
          footer: DefaultFooter
        }
      }
    ]
  }
]

const router = new VueRouter({
  mode: 'history',
  routes
})

export default router
